<aside
  class="fixed left-0 w-23 flex flex-col bg-white border-r border-gray-200 shadow h-full overflow-y-hidden z-1"
>
  <div class="flex flex-col justify-between flex-1">
    <nav class="nav">
      <div class="main-nav">
        <div
          class="flex flex-col self-end items-center px-4"
          style="font-size: 21px"
        >
          <!-- svg logo -->
          <img
            class="logo-pittogramma"
            src="./assets/icons/LogoWaste.svg"
            alt=""
          />
          <!-- svg logo -->
        </div>
        @for (
          route of sideNavRoutesToShow();
          track route.path;
          let last = $last;
          let first = $first
        ) {
          @if (!last) {
            @if (first) {
              <div
                style="padding: 1.3rem"
                class="flex flex-col items-center px-4 py-3 text-gray-600 transition-colors duration-300 transform rounded-md hover:bg-gray-100 grayscale cursor-pointer [&.menu-active>span]:font-bold"
                [routerLink]="route.path"
                [title]="route.title | translate"
                routerLinkActive="menu-active"
              >
                @if (route.img.includes(".svg")) {
                  <img
                    alt="icon menu"
                    [src]="route.img"
                    class="icon-svg opacity-85 py-3"
                  />
                } @else {
                  <i
                    class="pi pi-{{ route.img }} opacity-85 py-3"
                    style="font-size: 21px; color: var(--color-primary-waste)"
                  ></i>
                }
              </div>
            } @else if (shouldShowRoute()) {
              <div
                style="padding: 1.3rem"
                class="flex flex-col items-center px-4 py-3 text-gray-600 transition-colors duration-300 transform rounded-md hover:bg-gray-100 grayscale cursor-pointer [&.menu-active>span]:font-bold"
                [routerLink]="route.path"
                [title]="route.title | translate"
                routerLinkActive="menu-active"
              >
                @if (route.img.includes(".svg")) {
                  <img
                    alt="icon menu"
                    [src]="route.img"
                    class="icon-svg opacity-85 py-3"
                  />
                } @else {
                  <i
                    class="pi pi-{{ route.img }} opacity-85 py-3"
                    style="font-size: 21px; color: var(--color-primary-waste)"
                  ></i>
                }
              </div>
            }
          } @else {
            <div
              onKeyUp
              (click)="logout()"
              class="flex flex-col items-center px-4 py-3 text-gray-600 transition-colors duration-300 transform rounded-md hover:bg-gray-100 grayscale cursor-pointer [&.menu-active>span]:font-bold"
              routerLinkActive="menu-active"
            >
              @if (route.img.includes(".svg")) {
                <img
                  alt="icon menu"
                  [src]="route.img"
                  class="icon-svg opacity-85 py-3"
                />
              } @else {
                <i
                  class="pi pi-{{ route.img }} opacity-85 py-3"
                  style="font-size: 21px"
                ></i>
              }
            </div>
          }
        }
      </div>

      <div
        class="flex flex-col items-center px-4 py-3 text-gray-600 transition-colors duration-300 transform rounded-md hover:bg-gray-100 cursor-pointer mt-auto"
        [routerLink]="['/guida-supporto']"
        routerLinkActive="menu-active"
        [title]="'sidenav.help' | translate"
      >
        <i
          class="pi pi-question-circle opacity-85 py-3"
          style="font-size: 21px; color: var(--color-primary-waste)"
        ></i>
      </div>

      <div
        [pTooltip]="tooltipContent"
        tooltipStyleClass="user-info-tooltip"
        tooltipPosition="right"
        appendTo="body"
        class=""
      >
        <hr class="border-gray-200" />
        <div
          class="flex flex-col self-end items-center hover:bg-gray-100 cursor-pointer transition-colors duration-300 transform rounded-md"
          style="margin-top: 1rem"
        >
          <div class="user-icon">
            {{ authStore.user()!.given_name[0] }}
            {{ authStore.user()!.family_name[0] }}
          </div>

          <div class="container-cantiere">
            <span class="cantiere-text">
              {{
                authStore.selectedCantiereAuth()?.nomeCantiere ||
                  "Nessun cantiere associato"
              }}
            </span>
          </div>
        </div>
      </div>

      <ng-template #tooltipContent>
        <div>
          <span>
            {{ authStore.user()!.given_name }}
            {{ authStore.user()!.family_name }}
          </span>
          <div>
            <span>Cantiere: </span>
            <span>
              {{
                authStore.selectedCantiereAuth()?.nomeCantiere ||
                  "Nessun cantiere associato"
              }}
            </span>
          </div>
        </div>
      </ng-template>
    </nav>
  </div>
</aside>
